<div class="flex flex-col px-10 py-4 border-2 rounded-md" [ngClass]="hasError() ? 'border-red-500' : 'border-gray-900/10'">
    <div class="text-lg font-semibold my-1">{{ title() }}</div>

    <div class="flex items-center max-w-full h-28">
        <div
            class="bg-valamarbluesecondary/20 min-h-[7rem] p-2 min-w-[34rem] w-fit max-w-full my-2 overflow-auto border-black rounded-l-md flex items-center"
        >
            <div class="flex gap-2">
                @for (option of selected(); track option.masterId; let i = $index) {
                <div>
                    <div class="flex justify-between gap-6 items-center m-1 py-2 px-4 bg-white rounded-sm">
                        <div class="flex flex-col w-max">
                            <div class="text-lg">{{ option.name }}</div>
                        </div>
                        <button
                            type="button"
                            (click)="remove(i)"
                            class="valben-icon-button valben-icon-button--compact"
                            [attr.aria-label]="'Ukloni ' + option.name">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>
                }
            </div>
        </div>
        <div class="h-full">
            <div class="px-3 w-fit bg-valamarbluesecondary/20 flex h-full justify-center items-center rounded-r-md">
                @if (!dropdownOpen) {
                    <div
                        (click)="toggleDropdown()"
                        class="px-8 py-2 border-2 border-valamarblueprimary bg-white rounded-md font-semibold hover:bg-valamarblueprimary hover:text-white cursor-pointer"
                    >
                        NOVO
                    </div>
                }
            </div>
        </div>
    </div>

    @if (dropdownOpen) {
        <div class="my-2 flex items-center gap-2">
            <valben-searchable-select
                class="valben-entity-picker-select min-w-[34rem] w-fit max-w-full"
                [options]="availableOptions()"
                [loading]="loading()"
                placeholder="Odaberite lokaciju"
                [clearAfterSelection]="true"
                [panelClass]="['valben-searchable-select-panel', 'valben-entity-picker-panel', 'valben-entity-picker-panel--standard']"
                [value]="pickedId"
                (valueChange)="add($event)" />
            <button
                type="button"
                (click)="toggleDropdown()"
                class="valben-icon-button valben-entity-picker-close"
                aria-label="Zatvori odabir lokacije">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    }
</div>
